import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { Radio, Form, Row, Col, Select, Button } from "antd/lib";
import {
  chooseplan,
  sumInsuredamount,
  QuickQuoteHealth,
} from "../../Redux/actions/NumHealth";
import "./policyStep.css";
import { useHistory } from "react-router-dom";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import moment from "moment";
function PolicyStepsHealth(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuickPost = useSelector((state) => state?.vehicledetail?.quoteInput);
  const PrevPolDetails = useSelector(
    (state) => state?.vehicledetail?.prevpolicydetail
  );
  const healthdetail = useSelector((state) => state.healthdetail);
  const [product, setproduct] = useState([]);
  const [plan, setplan] = useState([]);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    dispatch(sumInsuredamount())
      .then((res) => {
        console.log(res);
        setproduct(res);
      })
      .catch((err) => {});
    dispatch(chooseplan())
      .then((res) => {
        console.log(res);
        setplan(res);
      })
      .catch((err) => {});
  }, [dispatch]);

  // console.log("carnumDetails", bikenumDetails);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  // console.log(selectedDate);

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };

  const onSubmit = (data) => {
    // alert(JSON.stringify(data));
    console.log(data);
    const today = moment();
    console.log(today.format("DD-MM-YYYY"));
    //setOpen(true);
    const results = plan.filter((element) => {
      // 👇️ using OR (||) operator
      return element.id === parseInt(data.chooseplan);
    });
    console.log(results);
    const auth = JSON.parse(localStorage.getItem("vibeReg"));
    const isuser = JSON.parse(localStorage.getItem("vibeUser"));
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    const personsdata = JSON.parse(localStorage.getItem("healthdetail"));
    // var Str = healthdetail.healthmodel;
    // var newStr = Str.replace(" yrs", "");
    // console.log(newStr);
    let post = {
      insurance_id: auth?.health_insurance_id,
      subInsuranceProductCode: results[0].subInsuranceProductCode,
      nonAbsProductCode: results[0].NonAbsProductCode, //0 or 1 - Integer
      PolicyType: "FLOATER",
      StartDate: today.format("YYYY-MM-DD"),
      // Age: newStr,
      // relationship: healthdetail.healthmake,
      pincode: healthdetail.healthnum,
      policyPeriod: 2,
      suminsured: data.suminsured.toString(),
      isPOSP: is_POSP,
      pospId: posp_id, //integer //Mandatory (0 for user 1 for POSP)
      persons: personsdata,
    };
    console.log(post);
    axiosInstance
      .post("v1/health_insurance/quickquotes", post)
      .then((res) => {
        console.log("QuickQuotes", res);
        console.log("respose :", res.status);
        // history.push("/planlayout");
        if (res.status === 200) {
          // if (!res.data.error) {
          let data = {
            data: res.data,
            post: post,
          };
          console.log(data);
          localStorage.setItem("quickquotes", JSON.stringify(data));
          dispatch(QuickQuoteHealth(data));
          history.push("/planlayouthealth");
          //setOpen(false);
          // }
        } else {
          //setOpen(false);
          message.error(res.data.error?.validationMessages?.join(","));
        }
      })
      .catch((err) => {
        console.log(err);
        //setOpen(false);
        message.error("Something Went Wrong Please try again!");
        // history.push("/planlayout");
      });
  };
  return (
    <>
      <NavbarJourney />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 110px)" }}
      >
        <div className="container">
          <h5 className="mb-5">
            <h3 className="text-center">
              Fill Some Information Below So We Can Provide Exact Quote
            </h3>
          </h5>
          <div className="row justify-content-center">
            <Form
              layout="vertical"
              form={form}
              // /style={{ width: "50%" }}
              className="col-xl-6 col-lg-6 col-md-12 ol-sm-12 form-health"
              requiredMark={false}
              onFinish={onSubmit}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24} className="justify-content-center">
                <Col span={20}>
                  <div className="h6 text-blue mb-3">
                    Choose Your Sum Insured
                  </div>
                  <Form.Item
                    // {...formItemLayout}
                    className="form-item-bg"
                    label="Sum Insured"
                    name="previousInsurerCode"
                    rules={[
                      {
                        required: true,
                        message: "Please select previous insurer",
                      },
                    ]}
                    //initialValue={QuickPost?.previousInsurerCode}
                  >
                    <Select
                      defaultValue="Select SumInsured"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={product?.map((p) => ({
                        key: p.id,
                        value: p.code,
                        label: p.name,
                      }))}
                      // onChange={(value, option) => {
                      //   setSelectedInsurer(option?.label)
                      // }}
                    />
                  </Form.Item>
                </Col>
                <Col span={20}>
                  <div className="h6 text-blue mb-3">Choose Plan</div>
                  <Form.Item
                    // {...formItemLayout}
                    className="form-item-bg"
                    label="Select Plan"
                    name="previousInsurerCode"
                    rules={[
                      {
                        required: true,
                        message: "Please select previous insurer",
                      },
                    ]}
                    //initialValue={QuickPost?.previousInsurerCode}
                  >
                    <Select
                      defaultValue="Select Plan"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={plan?.map((p) => ({
                        key: p.id,
                        value: p.code,
                        label: p.name,
                      }))}
                      // onChange={(value, option) => {
                      //   setSelectedInsurer(option?.label)
                      // }}
                    />
                  </Form.Item>
                </Col>
                <Col span={20}>
                  <div className="h6 text-blue mb-3">Existing illness</div>
                  <Form.Item
                    {...formItemLayout}
                    className="form-item-bg"
                    label="illness"
                    name="driverlicence"
                    rules={[
                      {
                        required: true,
                        message: "Please select",
                      },
                    ]}
                    // initialValue={
                    //   QuickPost?.driverlicence
                    //     ? QuickPost?.driverlicence
                    //     : "Yes"
                    // }
                  >
                    <Radio.Group
                      className="py-3 px-3 bg-white ant-radio-layout"
                      style={{
                        width: "100%",
                      }}
                    >
                      <Radio value="Yes">illness</Radio>
                      <Radio value="No">Surgical Procedure</Radio>
                      <Radio value="No">None Of the Above</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <div
                className="position-sticky bottom-0"
                style={{ height: "50px" }}
              >
                <div className="d-flex align-items-center justify-content-end container text-right py-2">
                  <p className="mb-0 mx-3">
                    By proceeding, you agree to the Terms & Conditions
                  </p>
                  <Form.Item className="mb-0" {...buttonItemLayout}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Get Quotes
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PolicyStepsHealth);
